// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/css/main.css";
//引入控制字体方法
import './config/rem'
// import { Button, Select, Input, Form, Option } from 'element-ui' //引入组件
import { VueCookie } from './cookie/cookie.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "./api/axios";
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.prototype.$cookie = VueCookie

Vue.use(MintUI)

Vue.use(ElementUI);
Vue.use(VueCookie)
import VDistpicker from 'v-distpicker'


// Vue.use(Button)
// Vue.use(Select)
// Vue.use(Input)
// Vue.use(Form)
// Vue.use(Option)
Vue.component('v-distpicker', VDistpicker);

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
import { Swipe, SwipeItem } from 'mint-ui';

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js